import { render, staticRenderFns } from "./OrderItemsExpansion.vue?vue&type=template&id=11c05c69&scoped=true"
import script from "./OrderItemsExpansion.vue?vue&type=script&lang=js"
export * from "./OrderItemsExpansion.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsExpansion.vue?vue&type=style&index=0&id=11c05c69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c05c69",
  null
  
)

export default component.exports